import React, { useEffect, useState } from 'react';
import { useSetRecoilState } from 'recoil';
import { css } from '@emotion/react';
import _ from 'lodash';

import { SwButtonSection, getFetcher } from '../../../../App';
import { Input, PrimaryButton } from '@components/atoms';
import { dialogContentsState } from '@components/templates/Dialog';
import SettingCommonMethods from '../../../../utils/settingCommon';
import { useCatchLeave } from '../../../../utils/hooks';
import { StyledReportWrap, StyledReportArea, StyledReportFlex } from './style';
import { submitDebounce } from '../../../../utils/lib';

export interface CtaSetting {
  notSuspected: boolean;
}

const Option = () => {
  const [isChanged, setIsChanged] = useState(false);
  const [originValue, setOriginValue] = useState<CtaSetting>({
    notSuspected: true,
  });
  const [value, setValue] = useState<CtaSetting>({
    notSuspected: true,
  });
  const { notSuspected } = value;
  const setDialogContents = useSetRecoilState(dialogContentsState);
  const { errorHandler } = SettingCommonMethods();

  // 값 변경이 있는 경우 새로고침, 탭닫기 막기
  useCatchLeave(isChanged);

  /**
   * setting 데이터 가져오기
   */
  const getSettingData = async () => {
    const url = 'api/setting/cta/option';
    const token = localStorage.getItem('PROD_ADMIN_ACCESS_TOKEN') || undefined;

    await getFetcher({
      method: 'GET',
      accessToken: token,
    })(url)
      .then((r) => {
        if (r.code === '200') {
          setValue(r.result);
          setOriginValue(r.result);
        } else {
          errorHandler(r);
        }
      })
      .catch((e) => {
        console.log(e, 'e');
      });
  };

  /**
   * 체크박스 토글
   */
  const changeSetting = (e: any) => {
    const { name, checked } = e.target;
    let obj: { [key: string]: boolean } = { [name]: checked };

    setValue((prev) => ({ ...prev, ...obj }));
  };

  /**
   * 변경값 저장 하기
   */
  const postReportSetting = async () => {
    // valid 체크
    const url = `api/setting/cta/option`;
    const token = localStorage.getItem('PROD_ADMIN_ACCESS_TOKEN') || undefined;

    const _body = {
      notSuspected: value.notSuspected,
    };

    await getFetcher({
      method: 'POST',
      accessToken: token,
      body: _body,
    })(url)
      .then(async (r) => {
        if (r.code === '200') {
          setDialogContents({
            type: 'plain',
            body: `It has been reflected.`,
            footer: (
              <PrimaryButton
                onClick={async () => {
                  setDialogContents({ type: 'hidden' });
                }}
              >
                OK
              </PrimaryButton>
            ),
          });
          setOriginValue(value);
        } else {
          errorHandler(r);
        }
      })
      .catch((e) => {
        console.log(e, 'e');
      });
  };

  /**
   * 최초 데이터 설정
   */
  useEffect(() => {
    getSettingData();
  }, []);

  useEffect(() => {
    // 값이 바꼈을 때 true
    const isSameValue = _.isEqual(value, originValue);
    setIsChanged(isSameValue); // true:
  }, [value, originValue]);

  return (
    <>
      <label>Option</label>

      <StyledReportWrap>
        <StyledReportArea>
          <strong>Result</strong>
          <StyledReportFlex>
            <Input type={'checkbox'} name={'notSuspected'} checked={notSuspected} onChange={(e) => changeSetting(e)}>
              Including not-Suspected
            </Input>
          </StyledReportFlex>
        </StyledReportArea>
      </StyledReportWrap>

      <SwButtonSection>
        <PrimaryButton
          styles={css`
            width: 145px;
            height: 48px;
            margin-top: 8px;
            font-size: 18px;
          `}
          onClick={submitDebounce(postReportSetting)}
          disabled={isChanged}
        >
          Apply
        </PrimaryButton>
      </SwButtonSection>
    </>
  );
};

export default Option;
